var baseIconButton = "base-icon-button__baseIconButton__TXKzr";
var icon = "base-icon-button__icon__FIIFq";

export { baseIconButton, icon };
//# sourceMappingURL=base-icon-button.module.css.js.map
